// removed by extract-text-webpack-plugin
module.exports = {"image":"src-components-ProductImage----ProductImage-module---image---3sv5Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductImage/ProductImage.module.scss
// module id = 479
// module chunks = 137591856104208 208175303390894